export default __webpack_public_path__ + "static/media/Ballroll_00306.72e9da65.png";